/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from "moment";

function toArray(value: unknown): any[] {
  if (Array.isArray(value)) {
    return value;
  }
  return typeof value === "string" ? JSON.parse(value) : [];
}

export function formatDateForSave(date: any): string {
  return moment(date).format("YYYY-MM-DD HH:mm:ss");
}

export function mapDotariToIds(dotari: any[] | undefined): any[] {
  return dotari ? dotari.map((dotare: any) => dotare.id) : [];
}

export function mergeIndexes(
  currentIndexes: unknown,
  addIndex?: string[],
  removeIndex?: string[]
): string[] {
  const indexes = new Set<string>(toArray(currentIndexes));

  addIndex?.forEach((index) => indexes.add(index));
  removeIndex?.forEach((index) => indexes.delete(index));

  return Array.from(indexes);
}

export function buildModifyByEntry(
  addedIndexes: string[],
  userId: string | null,
  date: string
) {
  return {
    index: addedIndexes.join(","),
    userId,
    date,
  };
}

export function mergeModifyBy(currentModifyBy: unknown, newEntries: any[]): any[] {
  const entries = new Set<any>(toArray(currentModifyBy));

  newEntries.forEach((entry) => entries.add(entry));

  return Array.from(entries);
}

export function shapeInvoicesFromResponse(resData: any) {
  return {
    clientInvoice: resData.clientInvoice ? resData.clientInvoice : [],
    providerInvoice: resData.providerInvoice ? resData.providerInvoice : [],
    OPInvoice: resData.OPInvoice ? resData.OPInvoice : [],
    reservedDocuments: resData.reservedDocuments
      ? resData.reservedDocuments
      : [],
  };
}
